import { defineMessages } from 'react-intl';

export default defineMessages({
    name:{
        id: 'common.MLSearchTypesService.Name',
        defaultMessage: 'Name'
    },
    lastNameFirstName:{
        id: 'common.MLSearchTypesService.Last Name, First (2 char min)',
        defaultMessage: 'Last Name, First (2 char min)'
    },
    solrLastNameFirstName:{
        id: 'common.MLSearchTypesService.Search',
        defaultMessage: 'Search'
    },
    policy:{
        id: 'common.MLSearchTypesService.Policy #',
        defaultMessage: 'Policy #'
    },
    submission:{
        id: 'common.MLSearchTypesService.Submission #',
        defaultMessage: 'Submission #'
    },
    expandedQuoteSearch:{
        id: 'common.MLSearchTypesService.Expanded Quote Search',
        defaultMessage: 'Expanded Quote Search'
    },
    EQS:{
        id: 'common.MLSearchTypesService.EQS',
        defaultMessage: 'EQS'
    },
    zipCode:{
        id: 'common.MLSearchTypesService.Zip Code',
        defaultMessage: 'Zip Code'
    },
    compRaterQuoteName:{
        id: 'common.MLSearchTypesService.Comp Rater Quote Name',
        defaultMessage: 'Comp Rater Quote Name'
    },
    CRQN:{
        id: 'common.MLSearchTypesService.CRQN',
        defaultMessage: 'CRQN'
    },
    compRaterQuoteID:{
        id: 'common.MLSearchTypesService.Comp Rater Quote ID',
        defaultMessage: 'Comp Rater Quote ID'
    },
    CRQI:{
        id: 'common.MLSearchTypesService.CRQI',
        defaultMessage: 'CRQI'
    },
    referenceNumber:{
        id: 'common.MLSearchTypesService.Reference Number',
        defaultMessage: 'Reference Number'
    }

});
